const strings = {
	popupAddToCart: "addtocartpopup.title",
	quantity: "addtocartpopup.unit",
	arrowLeft: "addtocartpopup.arrowLeft",
	arrowRight: "addtocartpopup.arrowRight",
	flexInsurance: "addtocartpopup.flex.insurance.label",
	flexInsuranceLink: "addtocartpopup.flex.insurance.link",
	flexInsuranceModalHeader: "addtocartpopup.flex.insurance.modal.header",
	flexInsuranceModalContent: "addtocartpopup.flex.insurance.modal.content",
	flexWithGamePassInformation: "addtocartpopup.flex.gamepass.information",
	insurance: "addtocartpopup.insurance",
	insuranceLink: "addtocartpopup.insuranceLink",
	insuranceRemove: "addtocartpopup.insuranceremove",
	before: "addtocartpopup.priceBefore",
	buy: "addtocartpopup.buy",
	loading: "addtocartpopup.loading",
	bought: "addtocartpopup.bought",
	continueShopping: "addtocartpopup.continueshopping",
	continueShoppingShort: "addtocartpopup.continueshopping.short",
	goToCart: "addtocartpopup.gotocart",
	goToCartShort: "addtocartpopup.gotocart.short",
	close: "addtocartpopup.close",
	enableaddtocartpopup: "addtocartpopup.enableaddtocartpopup",
	subscriptionCurrency: "addtocartpopup.subscription.currency",
	subscriptionKomplettPrice: "addtocartpopup.subscription.komplettprice",
	subscriptionTermsAndConditions:
		"addtocartpopup.subscription.termsandconditions",
	subscriptionSubName: "addtocartpopup.subscription.subname",
	subscriptionName: "addtocartpopup.subscription.name",
	subscriptionNotAvailable: "addtocartpopup.subscription.notavailable",
	["cart.safety.deal.modal.title"]: "cart.safety.deal.modal.title",
	["cart.safety.deal.modal.subtitle"]: "cart.safety.deal.modal.subtitle",
	["insurance-information"]: "insurance-information",
	["insurance-information-studentpc"]: "insurance-information-studentpc",
	["cart.flex.insurance.modal.title"]: "cart.flex.insurance.modal.title",
	["cart.flex.insurance.modal.subtitle"]: "cart.flex.insurance.modal.subtitle",
	["cart.flex.insurance.modal.content.description"]:
		"cart.flex.insurance.modal.content.description",
	["cart.flex.insurance.modal.content.list"]:
		"cart.flex.insurance.modal.content.list",
	["cart.flex.insurance.modal.content.descriptionMore"]:
		"cart.flex.insurance.modal.content.descriptionMore",
	["addtocartpopup.subscription.highlightThisIsFlex"]:
		"addtocartpopup.subscription.highlightThisIsFlex",
	["addtocartpopup.subscription.highlightPayToday"]:
		"addtocartpopup.subscription.highlightPayToday",
	["addtocartpopup.subscription.highlightFreeReturn"]:
		"addtocartpopup.subscription.highlightFreeReturn",
	["addtocartpopup.subscription.highlightReplaceAfter"]:
		"addtocartpopup.subscription.highlightReplaceAfter",
	["addtocartpopup.subscription.highlightNewOwner"]:
		"addtocartpopup.subscription.highlightNewOwner",
	["addtocartpopup.general.error"]: "addtocartpopup.general.error",
	["addtocartpopup.subscription.general.error"]:
		"addtocartpopup.subscription.general.error",
	["addtocartpopup.readmore.link"]: "addtocartpopup.readmore.link",
	["addtocartpopup.insurance.title"]: "addtocartpopup.insurance.title",
	["addtocartpopup.insurance.subtitle"]: "addtocartpopup.insurance.subtitle",
	["addtocartpopup.insurance.details"]: "addtocartpopup.insurance.details",
	["addtocartpopup.flex.insurance.title"]:
		"addtocartpopup.flex.insurance.title",
	["addtocartpopup.flex.insurance.subtitle"]:
		"addtocartpopup.flex.insurance.subtitle",
	["addtocartpopup.flex.insurance.details"]:
		"addtocartpopup.flex.insurance.details",
	["subscription.price.permonth"]: "subscription.price.permonth",
	["addtocartpopup.insurance.modal.button.yes"]:
		"addtocartpopup.insurance.modal.button.yes",
	["addtocartpopup.insurance.modal.button.no"]:
		"addtocartpopup.insurance.modal.button.no",
	["addtocartpopup.insurance.readmore"]: "addtocartpopup.insurance.readmore",
	["addtocartpopup.insurance.readless"]: "addtocartpopup.insurance.readless",
	["cart.flex.insurance.modal.content.mobile.list"]:
		"cart.flex.insurance.modal.content.mobile.list",
	["cart.insurance.modal.content.mobile.list"]:
		"cart.insurance.modal.content.mobile.list",
	["cart.flex.insurance.details.mobile.list"]:
		"cart.flex.insurance.details.mobile.list",
	["cart.insurance.details.mobile.list"]: "cart.insurance.details.mobile.list",
	["cart.flex.insurance.modal.content.tv.list"]:
		"cart.flex.insurance.modal.content.tv.list",
	["cart.insurance.modal.content.tv.list"]:
		"cart.insurance.modal.content.tv.list",
	["cart.flex.insurance.details.tv.list"]:
		"cart.flex.insurance.details.tv.list",
	["cart.insurance.details.tv.list"]: "cart.insurance.details.tv.list",
	["cart.flex.insurance.modal.content.komplett_pc.list"]:
		"cart.flex.insurance.modal.content.komplett_pc.list",
	["cart.insurance.modal.content.komplett_pc.list"]:
		"cart.insurance.modal.content.komplett_pc.list",
	["cart.flex.insurance.details.komplett_pc.list"]:
		"cart.flex.insurance.details.komplett_pc.list",
	["cart.insurance.details.komplett_pc.list"]:
		"cart.insurance.details.komplett_pc.list",
	["cart.flex.insurance.modal.content.monitor.list"]:
		"cart.flex.insurance.modal.content.monitor.list",
	["cart.insurance.modal.content.monitor.list"]:
		"cart.insurance.modal.content.monitor.list",
	["cart.flex.insurance.details.monitor.list"]:
		"cart.flex.insurance.details.monitor.list",
	["cart.insurance.details.monitor.list"]:
		"cart.insurance.details.monitor.list",
	["cart.flex.insurance.modal.content.white_goods.list"]:
		"cart.flex.insurance.modal.content.white_goods.list",
	["cart.insurance.modal.content.white_goods.list"]:
		"cart.insurance.modal.content.white_goods.list",
	["cart.flex.insurance.details.white_goods.list"]:
		"cart.flex.insurance.details.white_goods.list",
	["cart.insurance.details.white_goods.list"]:
		"cart.insurance.details.white_goods.list",
	["cart.flex.insurance.modal.content.pc_laptops.list"]:
		"cart.flex.insurance.modal.content.pc_laptops.list",
	["cart.insurance.modal.content.pc_laptops.list"]:
		"cart.insurance.modal.content.pc_laptops.list",
	["cart.flex.insurance.details.pc_laptops.list"]:
		"cart.flex.insurance.details.pc_laptops.list",
	["cart.insurance.details.pc_laptops.list"]:
		"cart.insurance.details.pc_laptops.list",
	["cart.flex.insurance.modal.content.console_vr.list"]:
		"cart.flex.insurance.modal.content.console_vr.list",
	["cart.insurance.modal.content.console_vr.list"]:
		"cart.insurance.modal.content.console_vr.list",
	["cart.flex.insurance.details.console_vr.list"]:
		"cart.flex.insurance.details.console_vr.list",
	["cart.insurance.details.console_vr.list"]:
		"cart.insurance.details.console_vr.list",
	["cart.flex.insurance.modal.content.desktop.list"]:
		"cart.flex.insurance.modal.content.desktop.list",
	["cart.insurance.modal.content.desktop.list"]:
		"cart.insurance.modal.content.desktop.list",
	["cart.flex.insurance.details.desktop.list"]:
		"cart.flex.insurance.details.desktop.list",
	["cart.insurance.details.desktop.list"]:
		"cart.insurance.details.desktop.list",
	["cart.flex.insurance.modal.content.tablet.list"]:
		"cart.flex.insurance.modal.content.tablet.list",
	["cart.insurance.modal.content.tablet.list"]:
		"cart.insurance.modal.content.tablet.list",
	["cart.flex.insurance.details.tablet.list"]:
		"cart.flex.insurance.details.tablet.list",
	["cart.insurance.details.tablet.list"]: "cart.insurance.details.tablet.list",
	["addtocartpopup.mobile.insurance.list"]:
		"addtocartpopup.mobile.insurance.list",
	["addtocartpopup.screen.insurance.title"]:
		"addtocartpopup.screen.insurance.title",
	["addtocartpopup.screen.insurance.list"]:
		"addtocartpopup.screen.insurance.list",
};

export function updateStrings(translations: any) {
	for (const key in strings) {
		strings[key] = translations[strings[key]];
	}
}

export default strings;
